module.exports = __webpack_public_path__ + "img/beautify2.033f3ce5.webp";